import { Truck, HardHat, LayoutGrid, Hammer, MapPin } from "lucide-react";

export const BRAND_DESCRIPTION = "Karmivo is a managed labour workforce platform in Jaipur, Rajasthan, India.";

const ITEMS = [
  { icon: Truck, t: "Loading & Unloading Labour", d: "Trained workers for shifting, loading and unloading goods." },
  { icon: HardHat, t: "Daily Labour / General Labour", d: "General purpose daily wage workers for any site need." },
  { icon: LayoutGrid, t: "Tiles Work Labour", d: "Experienced masons for floor and wall tiling." },
  { icon: Hammer, t: "House Repair / Renovation Labour", d: "Skilled labour for repair, plaster, paint and renovation." },
];

export const AboutKarmivo = () => (
  <section id="about" className="max-w-7xl mx-auto px-6 pb-24" data-testid="about-karmivo-section">
    <div className="grid lg:grid-cols-5 gap-10 items-start">
      <div className="lg:col-span-2">
        <div className="text-xs uppercase tracking-widest text-orange-600 font-bold">About Karmivo</div>
        <h2 className="font-display text-3xl sm:text-4xl font-bold text-slate-900 mt-2">Jaipur's managed labour workforce platform</h2>
        <p className="mt-4 text-slate-700 text-base leading-relaxed" data-testid="about-brand-description">
          {BRAND_DESCRIPTION} We supply verified workers and full labour teams, and our dispatch system assigns them to your job.
        </p>
        <p className="mt-3 text-slate-600 text-sm leading-relaxed">
          Every worker goes through KYC and gets a Karmivo ID card with a QR code you can check. You pay online, and the job closes with a 6-digit code once the work is done.
        </p>
        <div className="mt-5 inline-flex items-center gap-2 text-sm text-slate-600"><MapPin size={16} className="text-orange-600"/> Serving Jaipur, Rajasthan</div>
      </div>
      <ul className="lg:col-span-3 grid sm:grid-cols-2 gap-4" data-testid="about-services-list">
        {ITEMS.map(({ icon: Icon, t, d }) => (
          <li key={t} className="rounded-2xl border border-slate-200 bg-white p-5">
            <Icon size={20} className="text-orange-600"/>
            <h3 className="mt-3 font-display font-bold text-slate-900">{t}</h3>
            <p className="mt-1 text-sm text-slate-600 leading-relaxed">{d}</p>
          </li>
        ))}
      </ul>
    </div>
  </section>
);
